
import './lib/blockrightclick';
import {zImgPath, config, custOpt} from './config/config';
import {imgWin, zSort, parseURL, isMobileDevice, onError} from './util/util';
import {createProjectInfoStore, createProjectInfoStoreJson, populateDataFromXmlStore, propertyAddress} from './data/data';

import '../styles/index.scss';

dojo.require("dojo.window");
dojo.require("dojox.data.XmlStore");
dojo.require('dojox.fx');

var cfg;
var photoData = {items: [], type: "photo"};
var planData = {items: [], type: "plan"};
var selectData = null;
var timeoutId = null;
var resizeTimer = null;
var slideTimer = null;
var tochIndex = null;
var fishEyeOffset = 0;
var imgId = "imgSlide1";
var slideIndex = 0;
var touchSlideIndex = 0;
var isPlay = true;
var isFloorplan = null;
var disableAnim = true;
var isPauseAnimation = false;
var isResize = false;
var isHidenFishEye = false;
var fishEyeHided = false;
var random = null;
var startTime = null;
var interval = 0;
var t = null;
var l = null;
var s = null;
var tempHeigth = 0;
var tempWidth = 0;
var fishEyeAnimation = null;
var fishEyeAnimationVertical = null;
var epcLink = null;
var walk3dLink = null;
var attachmentLink = null;
var buttonCount = 0;
var typesCount = 0;
var canFullScreen = false;
var statusBarAnimation = null;
var curYPos = 0,
    curTop = 0,
    curDown = false,
    lastTop = 0;
var panelHeight;
var customerOptions = {};

dojo.addOnLoad(function () {
    if (dojo.isIE === undefined) {
        document.body.addEventListener('touchmove', function (event) {
            event.preventDefault();
        }, false);
    }
    var vp = dojo.window.getBox();
    tempHeigth = vp.h;
    tempWidth = vp.w;
    customerOptions = custOpt();
    if(isMobileDevice) {
        window.scrollTo(0, 0);
        dojo.attr(dojo.byId("statusBarActive"), {
            style:{
                width: '100%'
            }
        });
        dojo.attr(dojo.byId("statusBar"), {
            style:{
                width: '100%'
            }
        });
    }

    var url = parseURL();
    var mainContent = dojo.byId("mainContent");

    if (url.args.project !== undefined) {
        document.title = "zentuvo - " + url.args.project;
        cfg = config(url.args.project);
        // createProjectInfoStore(url.args.project, (...params)=>{getImageList(...params);});
        createProjectInfoStoreJson(url.args.project, (...params)=>{getImageListJson(...params);});
    } else {
        onError();
    }
});

var renderMainUI = function() {
    window.addEventListener('blur', function(){
      if(dojo.byId("zView")) {
        if(isPlay){
            pause();
        }
      }
    });

    var vp = dojo.window.getBox();
    if(isMobileDevice && customerOptions.FLOORPLANS.value == "") {
        photoData.items = photoData.items.concat(planData.items);
    }
    if(customerOptions.INTRO.value != "") {
        var intro = {
            "type": customerOptions.INTRO.value,
            "generate": true
        };
        if(photoData.items.length > 0) {
            photoData.items.unshift(intro);
        } else if(planData.items.length > 0) {
            planData.items.unshift(intro);
        }
    }
    if(customerOptions.OUTRO.value != "") {
        var outro = {
            "type": customerOptions.OUTRO.value,
            "generate": true
        };
        if(photoData.items.length > 0) {
            photoData.items.push(outro);
        } else if(planData.items.length > 0) {
            planData.items.push(outro);
        }
    }
    if(planData.items.length > 0 && customerOptions.FLOORPLANS.value == "") {
        typesCount++;
        selectData = planData;
    }
    if(photoData.items.length > 0) {
        typesCount++;
        selectData = photoData;
    }
    if(typesCount > 1) {
        buttonCount += typesCount;
    }
    dojo.connect(window, "onresize", resize);
    if(dojo.isIos) {
        dojo.connect(window, "orientationchange", resize());
    }
    dojo.attr(dojo.byId("loading"), {
        'class': 'changeSlide'
    });
    if(!isMobileDevice) {
        var divPrev = dojo.create("div", {
            id: 'prevSlide',
            'class': 'button',
            style: {'top': '5px',
                    'left': ((vp.w + vp.w%2) / 2 - 75) + 'px',
                    'position': 'absolute'}
        }, mainContent);
        var divNext = dojo.create("div", {
            id: 'nextSlide',
            'class': 'button',
            style: {'top': '5px',
                    'left': ((vp.w + vp.w%2) / 2 + 25) + 'px',
                    'position': 'absolute'}
        }, mainContent);
        dojo.connect(divPrev, 'onclick', prevSlide);
        dojo.connect(divNext, 'onclick', nextSlide);
    }
    if(!isMobileDevice) {
        var divPlayPause = dojo.create("div", {
            id: 'playPause',
            'class': 'button',
            style: {'top': '5px',
                    'left': ((vp.w + vp.w%2) / 2 - 25) + 'px',
                    'position': 'absolute'}
        }, mainContent);
        dojo.connect(divPlayPause, 'onclick', function(){
            if(isPlay){
                pause();
            } else {
                play();
            }
        });
    }

    //createPanel();
    if(buttonCount > 0 && !isMobileDevice){
        createSwitchTypePanel();
    }
    if(selectData.type == "pano"){
        hideControls();
    }
    isMobileDevice ? createPanelMobile() : createPanel();
    isMobileDevice ? createNavigationPanelMobile() : createNavigationPanel();
    isHidenFishEye = true;
    timeoutId = setTimeout(hideFishEye, 3000);
    changeSlide();
};

var play = function() {
    if(!isPlay){
        dojo.attr(dojo.byId("playPause"), {
            style:{
                'backgroundPosition': 'left'
            }
        });
        if(statusBarAnimation != null) {
            statusBarAnimation.play();
        }
        isPlay = true;
        if((dojo.isWebKit > 500 || dojo.isFF > 10 || dojo.isOpera >= 12 || dojo.isIE > 9) && isFloorplan == false && !disableAnim){
            if(isPauseAnimation){
                dojo.attr(dojo.byId(((imgId == "imgSlide1") ? "imgSlide2" : "imgSlide1") + '0'), {
                    style:{
                        'transform': 'scale(' + s + ')translate(' + l + 'px, ' + t + 'px)',
                        'MozTransform': 'scale(' + s + ')translate3d(' + l + 'px, ' + t + 'px, 0px)',
                        '-webkit-transform': 'scale(' + s + ')translate3d(' + l + 'px, ' + t + 'px, 0px)',
                        'OTransform': 'scale(' + s + ')translate(' + l + 'px, ' + t + 'px)',
                        '-webkit-transition': '-webkit-transform ' + (10 - interval/1000) + 's linear'
                    }
                });
                startTime = new Date();
            } else {
                if(dojo.byId(slideIndex + "") != null){
                    dojo.attr(dojo.byId(slideIndex + ""), {
                        style:{
                            'borderColor': '#cccccc'
                        }
                    });
                }
                slideIndex = ((slideIndex + 1) == selectData.items.length) ? 0 : (slideIndex + 1);
                isResize = false;
                changeSlide();
            }
        } else {
            if(dojo.byId(slideIndex + "") != null){
                dojo.attr(dojo.byId(slideIndex + ""), {
                    style:{
                        'borderColor': '#cccccc'
                    }
                });
            }
            slideIndex = ((slideIndex + 1) == selectData.items.length) ? 0 : (slideIndex + 1);
            changeSlide();
        }
    }
};

var pause = function() {
    if(isPlay){
        dojo.attr(dojo.byId("playPause"), {
            style:{
                'backgroundPosition': 'right'
            }
        });
        if(statusBarAnimation != null) {
            statusBarAnimation.pause();
        }
        isPlay = false;
        if((dojo.isWebKit > 500 || dojo.isFF > 10 || dojo.isOpera >= 12 || dojo.isIE > 9) && isFloorplan == false && !disableAnim){
            interval += (new Date()) - startTime;
            if(interval < 9500){
                var s2 = (s == 1) ? 1 : (s - 1) * interval / 10000 + 1;
                var l2 = l * interval / 10000;
                var t2 = t * interval / 10000;
                dojo.attr(dojo.byId(((imgId == "imgSlide1") ? "imgSlide2" : "imgSlide1") + '0'), {
                    style:{
                        'transform': 'scale(' + s2 + ')translate(' + l2 + 'px, ' + t2 + 'px)',
                        'MozTransform': 'scale(' + s2 + ')translate3d(' + l2 + 'px, ' + t2 + 'px, 0px)',
                        '-webkit-transform': 'scale(' + s2 + ')translate3d(' + l2 + 'px, ' + t2 + 'px, 0px)',
                        'OTransform': 'scale(' + s2 + ')translate(' + l2 + 'px, ' + t2 + 'px)',
                        '-webkit-transition': '-webkit-transform 0.1s linear'
                    }
                });
                isPauseAnimation = true;
            }
        }
    }
};

var prevSlide = function() {
    if(dojo.byId(slideIndex + "") != null){
        dojo.attr(dojo.byId(slideIndex + ""), {
            style:{
                'borderColor': '#cccccc'
            }
        });
    }
    slideIndex = (slideIndex <= 0) ? (selectData.items.length - 1) : (slideIndex - 1);
    isResize = false;
    changeSlide();
};

var nextSlide = function() {
    if(dojo.byId(slideIndex + "") != null){
        dojo.attr(dojo.byId(slideIndex + ""), {
            style:{
                'borderColor': '#cccccc'
            }
        });
    }
    slideIndex = ((slideIndex + 1) == selectData.items.length) ? 0 : (slideIndex + 1);
    isResize = false;
    changeSlide();
};

var hideFishEye = function() {
    if(!isMobileDevice){
        dojo.fx.slideTo({
            top: 80,
            left: parseFloat(dojo.byId("divUp").style.left),
            node: dojo.byId("divUp"),
            duration: 700
        }).play();
    } else {
        dojo.attr(dojo.byId("divPanel"), {
            style:{
                'opacity': '0',
                'transition': 'opacity 0.7s linear'
            }
        });
    }
    fishEyeHided = true;
};

var createPanel = function() {
    var mainContent = dojo.byId("mainContent");
    if(document.documentElement.requestFullScreen || document.documentElement.mozRequestFullScreen || document.documentElement.webkitRequestFullScreen){
        canFullScreen = true;
    }
    var height = 5 + (canFullScreen ? 45 : 0) + (customerOptions.SOCIAL_MEDIA.value == "" ? 90 : 0) + ((customerOptions.HOME.value == "homepage") ? 45 : 0) + 45;
    if(isMobileDevice) {
        height = 5 + (canFullScreen ? 45 : 0) + 45;
    }
    var divPanel = dojo.create("div", {
        id: 'divPanel',
        style: {'position': 'absolute',
                'bottom': '5px',
                'left': '5px',
                'overflow': 'hidden',
                'width': '50px',
                'height': height}
    }, mainContent);
    if(customerOptions.SOCIAL_MEDIA.value == "" && !isMobileDevice) {
        var aFacebook = dojo.create("a", {
            target:"_blank",
            href: cfg.facebookURL
        }, divPanel);
        var divFacebook = dojo.create("div", {
            id: 'facebook',
            'class': 'button'
        }, aFacebook);
        var aTweeter = dojo.create("a", {
            target:"_blank",
            href: cfg.twitterURL
        }, divPanel);
        var divTweeter = dojo.create("div", {
            id: 'tweeter',
            'class': 'button'
        }, aTweeter);
    }
    if(!isMobileDevice) {
        var divPrint = dojo.create("div", {
            id: 'print',
            'class': 'button'
        }, divPanel);
        dojo.connect(divPrint, 'onclick', function(){
            if(slideIndex >= 0){
                imgWin(selectData.items[slideIndex].large);
            }
        });
    }
    if(customerOptions.HOME.value == "homepage") {
        var aHome = dojo.create("a", {
            target:"_blank",
            href: homeLink
        }, divPanel);
        var divHome = dojo.create("div", {
            id: 'home',
            'class': 'button'
        }, aHome);
    }
    if(canFullScreen){
        var divFullscreen = dojo.create("div", {
            id: 'fullscreen',
            'class': 'button'
        }, divPanel);
        dojo.connect(divFullscreen, 'onclick', function(){
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
    }
};

var createPanelMobile = function() {
    var vp = dojo.window.getBox();
    var mainContent = dojo.byId("mainContent");
    if(document.documentElement.requestFullScreen || document.documentElement.mozRequestFullScreen || document.documentElement.webkitRequestFullScreen){
        canFullScreen = true;
    }
    panelHeight = 5 + (canFullScreen ? 45 : 0) + ((customerOptions.HOME.value == "homepage") ? 45 : 0) + 90;
    var top = "5px";
    if(dojo.isIos && vp.w > vp.h) {
        top = (vp.h - panelHeight) / 2 + "px";
    }
    var divPanel = dojo.create("div", {
        id: 'divPanel',
        style: {'position': 'absolute',
                'top': top,
                'left': '5px',
                'overflow': 'hidden',
                'width': '50px'}
    }, mainContent);

    var divPlayPause = dojo.create("div", {
        id: 'playPause',
        'class': 'button'
    }, divPanel);

    dojo.connect(divPlayPause, 'onclick', function(){
        if(isPlay){
            pause();
        } else {
            play();
        }
    });

    if(customerOptions.HOME.value == "homepage") {
        var aHome = dojo.create("a", {
            target:"_blank",
            href: homeLink
        }, divPanel);
        var divHome = dojo.create("div", {
            id: 'home',
            'class': 'button'
        }, aHome);
    }

    var divNavigation = dojo.create("div", {
        id: 'navigation',
        'class': 'button'
    }, divPanel);

    dojo.connect(divNavigation, 'onclick', function() {
        console.log(imgId);
        setTimeout(function(){dojo.byId((imgId == "imgSlide1") ? "imgSlide2" : "imgSlide1").innerHTML = "";}, 600);
        pause();
        dojo.attr(dojo.byId("divPanel"), {
            style:{
                'opacity': '0',
                'transition': 'opacity 0.5s linear'
            }
        });
        dojo.attr(dojo.byId("divDown"), {
            'class': 'changeSlide topSlide',
            style: {'zIndex' : '100'}
        });
    });

    if(canFullScreen){
        var divFullscreen = dojo.create("div", {
            id: 'fullscreen',
            'class': 'button'
        }, divPanel);
        dojo.connect(divFullscreen, 'onclick', function(){
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
    }
};

var createSwitchTypePanel = function() {
    var mainContent = dojo.byId("mainContent");
    var divPlayPause = dojo.byId("playPause");
    var divSwitchTypePanel = dojo.create("div", {
        id: 'divTypePanel'
    }, mainContent);
    if(epcLink != null) {
        var a = dojo.create("a", {
            href: epcLink,
            target: "_blank"
        }, divSwitchTypePanel);
        dojo.create("div", {
            id: 'epc',
            'class': 'button'
        }, a);
    }
    if(walk3dLink != null) {
        var a = dojo.create("a", {
            href: walk3dLink,
            target: "_blank"
        }, divSwitchTypePanel);
        var divWalk3d = dojo.create("div", {
            id: 'walk3d',
            'class': 'button'
        }, a);
    }
    if(attachmentLink != null) {
        var a = dojo.create("a", {
            href: attachmentLink,
            target: "_blank"
        }, divSwitchTypePanel);
        var divAttachment = dojo.create("div", {
            id: 'attachment',
            'class': 'button'
        }, a);
    }
    if(typesCount > 1) {
        if(photoData.items.length > 0){
            var divPhoto = dojo.create("div", {
                id: 'photo',
                'class': 'button'
            }, divSwitchTypePanel);
            dojo.connect(divPhoto, 'onclick', function(){
                if(selectData.type != "photo"){
                    dojo.attr(divPlayPause, {
                    style:{
                            'backgroundPosition': 'left'
                        }
                    });
                    isPlay = true;
                    selectData = photoData;
                    showControls();
                    fishEyeOffset = 0;
                    slideIndex = 0;
                    createNavigationPanel();
                    timeoutId = setTimeout(hideFishEye, 3000);
                    changeSlide();
                }
            });
        }
        if(planData.items.length > 0){
            var divPlan = dojo.create("div", {
                id: 'plan',
                'class': 'button'
            }, divSwitchTypePanel);
            dojo.connect(divPlan, 'onclick', function(){
                if(selectData.type != "plan"){
                    dojo.attr(divPlayPause, {
                    style:{
                            'backgroundPosition': 'left'
                        }
                    });
                    isPlay = true;
                    selectData = planData;
                    showControls();
                    fishEyeOffset = 0;
                    slideIndex = 0;
                    createNavigationPanel();
                    timeoutId = setTimeout(hideFishEye, 3000);
                    changeSlide();
                }
            });
        }
    }
};

var hideControls = function() {
    dojo.attr(dojo.byId("prevSlide"), {
        style:{
            'display': 'none'
        }
    });
    dojo.attr(dojo.byId("nextSlide"), {
        style:{
            'display': 'none'
        }
    });
    dojo.attr(dojo.byId("playPause"), {
        style:{
            'display': 'none'
        }
    });
    dojo.attr(dojo.byId("print"), {
        style:{
            'display': 'none'
        }
    });
    dojo.attr(dojo.byId("divPanel"), {
        style:{
            'height': (canFullScreen ? '140px' : '95px')
        }
    });
};

var showControls = function() {
    dojo.attr(dojo.byId("prevSlide"), {
        style:{
            'display': 'block'
        }
    });
    dojo.attr(dojo.byId("nextSlide"), {
        style:{
            'display': 'block'
        }
    });
    dojo.attr(dojo.byId("playPause"), {
        style:{
            'display': 'block'
        }
    });
    dojo.attr(dojo.byId("print"), {
        style:{
            'display': 'block'
        }
    });
    dojo.attr(dojo.byId("divPanel"), {
        style:{
            'height': (canFullScreen ? '185px' : '140px')
        }
    });
};

var createNavigationPanel = function() {
    var mainContent = dojo.byId("mainContent");
    var vp = dojo.window.getBox();
    if(dojo.byId("divDown") != null){
        dojo.destroy(dojo.byId("divDown"));
    }
    var divDown = dojo.create("div", {
        id: 'divDown',
        style: {'position': 'absolute',
                'bottom': '0px',
                'overflow': 'hidden',
                'left': (vp.w * 0.15) + 'px',
                'width': (vp.w * 0.7) + 'px',
                'height': '110px'}
    }, mainContent);
    var width = 96 * selectData.items.length;
    if((vp.w * 0.7) < width){
        var divUp = dojo.create("div", {
            id: 'divUp',
            style: {'left': '0px',
                    'height': '110px',
                    'width': width + 'px',
                    'position': 'relative'}
        }, divDown);
    } else {
        var divUp = dojo.create("div", {
            id: 'divUp',
            style: {'height': '110px',
                    'position': 'relative',
                    'left': ((vp.w * 0.7 - width) / 2) + 'px',
                    'width': width + 'px'}
        }, divDown);
        if(dojo.isIE > 5){
            fishEyeOffset = (vp.w * 0.7 - width) / 2;
        }
    }
    var i = 0;
    var itemClass = isMobileDevice ? "" : "topFishEye";
    dojo.forEach(selectData.items, function(item){
        var backgroundSize = "cover";
        if(item.generate) {
            backgroundSize = "contain";
        }
        var div = dojo.create("div", {
            id: i++,
            'class': itemClass,
            style: {'position': 'relative',
                    'cursor': 'pointer',
                    'width': '82px',
                    'height': '55px',
                    'display': 'inline-block',
                    'float': 'left',
                    'margin': '30px 4px',
                    'border': '3px solid #cccccc',
                    'backgroundImage': item.type == "address" ? 'none' : 'url("' + item.thumb + '")',
                    'backgroundPosition': 'center',
                    'backgroundRepeat': 'no-repeat',
                    'backgroundColor': 'white',
                    'backgroundSize': backgroundSize}
        }, divUp);
        if(item.type == "address" || item.type == "zView") {
            var divTable = dojo.create("div", {
                style: {
                    'display':'table',
                    'height': '100%',
                    'width': '100%',
                    'textAlign': 'center',
                    'backgroundColor': item.type == 'zView' ? '#E21F1D' : '#eeeeee'
                }
            }, div);
            var divText = dojo.create("div", {
                style: {
                    'display':'table-cell',
                    'verticalAlign': 'middle'
                }
            }, divTable);
            if(item.type == "zView") {
                dojo.create("img", {src: "resources/zView.png"}, divText);
            } else {
                var divText2 = dojo.create("div", {}, divText);
                divText2.innerHTML = propertyAddress;
            }
        }
        if(!isMobileDevice){
            dojo.connect(div, 'onmouseover', function(){
                if(parseInt(div.id) != 0) {
                    dojo.attr(dojo.byId((parseInt(div.id) - 1) + ""), {
                        'class': 'topFishEye nearbyLeftFishEye'
                    });
                }
                if(parseInt(div.id) > 1) {
                    for(var  i = (parseInt(div.id) - 2); i >= 0; i--){
                        dojo.attr(dojo.byId(i + ""), {
                            'class': 'topFishEye leftFishEye'
                        });
                    }
                }
                if((parseInt(div.id) + 1) != selectData.items.length) {
                    dojo.attr(dojo.byId((parseInt(div.id) + 1) + ""), {
                        'class': 'topFishEye nearbyRightFishEye'
                    });
                }
                if((parseInt(div.id) + 2) < selectData.items.length) {
                    for(var  i = (parseInt(div.id) + 2); i < selectData.items.length; i++){
                        dojo.attr(dojo.byId(i + ""), {
                            'class': 'topFishEye rightFishEye'
                        });
                    }
                }
            });
            dojo.connect(div, 'onmouseout', function(){
                if(parseInt(div.id) != 0) {
                    dojo.attr(dojo.byId((parseInt(div.id) - 1) + ""), {
                        'class': 'topFishEye'
                    });
                }
                if(parseInt(div.id) > 1) {
                    for(var  i = (parseInt(div.id) - 2); i >= 0; i--){
                        dojo.attr(dojo.byId(i + ""), {
                            'class': 'topFishEye'
                        });
                    }
                }
                if((parseInt(div.id) + 1) != selectData.items.length) {
                    dojo.attr(dojo.byId((parseInt(div.id) + 1) + ""), {
                        'class': 'topFishEye'
                    });
                }
                if((parseInt(div.id) + 2) < selectData.items.length) {
                    for(var  i = (parseInt(div.id) + 2); i < selectData.items.length; i++){
                        dojo.attr(dojo.byId(i + ""), {
                            'class': 'topFishEye'
                        });
                    }
                }
            });
        }
        dojo.connect(div, 'onclick', function(){
            if(isMobileDevice){
                if(tochIndex){
                    if(dojo.byId(slideIndex + "") != null){
                        dojo.attr(dojo.byId(slideIndex + ""), {
                            style:{
                                'borderColor': '#cccccc'
                            }
                        });
                    }
                    slideIndex = parseInt(div.id);
                    isResize = false;
                    changeSlide();
                }
                if(tochIndex == null) {
                    touchSlideIndex = parseInt(div.id);
                }
            } else {
                if(dojo.byId(slideIndex + "") != null){
                    dojo.attr(dojo.byId(slideIndex + ""), {
                        style:{
                            'borderColor': '#cccccc'
                        }
                    });
                }
                slideIndex = parseInt(div.id);
                isResize = false;
                changeSlide();
            }
        });
    }, this);

    dojo.connect(document.documentElement, "onmousemove", this, function(event){
        var width = 96 * selectData.items.length;
        var divUp = dojo.byId("divUp");
        var vp = dojo.window.getBox();
        var event = event || window.event;
        if((event.clientX >= vp.w * 0.15) && (event.clientX <= vp.w * 0.85) &&
            (event.clientY >= vp.h - 110) && (event.clientY < vp.h)){
            if((event.clientX <= (vp.w * 0.15 + 100) || event.clientX >= (vp.w * 0.85 - 100)) && (vp.w * 0.7) < width){
                if(event.clientX >= (vp.w * 0.85 - 100) && fishEyeAnimation == null){
                    fishEyeAnimation = dojo.fx.slideTo({
                        left: (vp.w * 0.7 - width - 28),
                        top: 0,
                        node: divUp,
                        duration: (parseFloat(divUp.style.left) - (vp.w * 0.7 - width)) / 0.3
                    }).play();
                }
                if(event.clientX <= (vp.w * 0.15 + 100) && fishEyeAnimation == null){
                    fishEyeAnimation = dojo.fx.slideTo({
                        left: 28,
                        top: 0,
                        node: divUp,
                        duration: (0 - parseFloat(divUp.style.left)) / 0.3
                    }).play();
                }
                dojo.connect(fishEyeAnimation, 'onEnd', function(){fishEyeAnimation = null;});
            } else {
                if(fishEyeAnimation != null) {
                    fishEyeAnimation.stop();
                    fishEyeAnimation = null;
                }
                if(fishEyeAnimationVertical == null) {
                    fishEyeAnimationVertical = dojo.fx.slideTo({
                        top: 0,
                        left: parseFloat(divUp.style.left),
                        node: divUp,
                        duration: 700
                    }).play();
                    dojo.connect(fishEyeAnimationVertical, 'onEnd', function(){fishEyeAnimationVertical = null;});
                }
            }
            isHidenFishEye = false;
            if(timeoutId != null && !(timeoutId === undefined)){
                clearTimeout(timeoutId);
            }
        } else {
            if(!isHidenFishEye){
                isHidenFishEye = true;
                timeoutId = setTimeout(hideFishEye, 3000);
            }
            if(fishEyeAnimation != null) {
                fishEyeAnimation.stop();
                fishEyeAnimation = null;
            }
        }
    });
};

var createNavigationPanelMobile = function() {
    var mainContent = dojo.byId("mainContent");
    var vp = dojo.window.getBox();
    var divDown = dojo.create("div", {
        id: 'divDown',
        "class": "changeSlide",
        style: {'width': '100%',
                'minHeight': '100%',
                'backgroundColor': '#eeeeee',
                'zIndex': "-100"}
    }, mainContent);

    if(dojo.isIos) {
        divDown.addEventListener('touchmove', function(e){
            if(curDown === true){
                var vp = dojo.window.getBox();
                var top = curTop - (curYPos - e.pageY);
                if(top > 0) {top = 0;}
                if(top < (vp.h - divDown.clientHeight)) {{top = vp.h - divDown.clientHeight;}}
                lastTop = top;
                dojo.attr(dojo.byId("divDown"), {
                    style: {'top' : top + "px"}
                });
            }
        });
        divDown.addEventListener('touchstart', function(e){ curDown = true; curYPos = e.pageY;});
        divDown.addEventListener('touchend', function(e){ curDown = false; curTop = lastTop;});
    } else {
        dojo.connect(divDown, "touchmove", this, function(e){
        if(curDown === true){
                var vp = dojo.window.getBox();
                var top = curTop - (curYPos - e.pageY);
                if(top > 0) {top = 0;}
                if(top < (vp.h - divDown.clientHeight)) {{top = vp.h - divDown.clientHeight;}}
                lastTop = top;
                dojo.attr(dojo.byId("divDown"), {
                    style: {'top' : top + "px"}
                });
            }
        });
        dojo.connect(divDown, "touchstart", this, function(e){ curDown = true; curYPos = e.pageY;});
        dojo.connect(divDown, "touchend", this, function(e){ curDown = false; curTop = lastTop;});
    }


    dojo.forEach(selectData.items, function(item, i) {
        var backgroundSize = "cover";
        if(item.generate) {
            backgroundSize = "contain";
        }
        var div = dojo.create("div", {
            id: i,
            style: {'position': 'relative',
                    'cursor': 'pointer',
                    'width': '82px',
                    'height': '55px',
                    'display': 'inline-block',
                    'float': 'left',
                    'margin': '7px',
                    'border': '3px solid #cccccc',
                    'backgroundImage': item.type == "address" ? 'none' : 'url("' + item.thumb + '")',
                    'backgroundPosition': 'center',
                    'backgroundRepeat': 'no-repeat',
                    'backgroundColor': 'white',
                    'backgroundSize': backgroundSize}
        }, divDown);
        if(item.type == "address") {
            var divTable = dojo.create("div", {
                style: {
                    'display':'table',
                    'height': '100%',
                    'width': '100%',
                    'textAlign': 'center',
                    'backgroundColor': '#eeeeee'
                }
            }, div);
            var divText = dojo.create("div", {
                style: {
                    'display':'table-cell',
                    'verticalAlign': 'middle'
                }
            }, divTable);
            var divText2 = dojo.create("div", {}, divText);
            divText2.innerHTML = propertyAddress;
        }
        dojo.connect(div, 'onclick', function() {
            dojo.attr(dojo.byId("divDown"), {
                'class': 'changeSlide',
                style: {
                    'zIndex' : '-100',
                    'top' : "0px"
                }
            });
            if(dojo.byId(slideIndex + "") != null){
                dojo.attr(dojo.byId(slideIndex + ""), {
                    style:{
                        'borderColor': '#cccccc'
                    }
                });
            }
            slideIndex = parseInt(div.id);
            isResize = false;
            changeSlide();
        });
    }, this);
};

var getImageDimensions = function(_img) {
    if(selectData.items[slideIndex].width === undefined){
        selectData.items[slideIndex].width = _img.width;
    }
    if(selectData.items[slideIndex].height === undefined){
        selectData.items[slideIndex].height = _img.height;
    }
};

var sizeToWindow = function(_img) {
    var vp = dojo.window.getBox();
    var _imgWidth = selectData.items[slideIndex].width;
    var _imgHeight = selectData.items[slideIndex].height;
    if((_imgWidth / _imgHeight > 1 && vp.w / vp.h > 1) ||
        (_imgWidth / _imgHeight < 1 && vp.w / vp.h < 1)) {
        var largeWidth;
        var largeHeight;
        var left = 0;
        var top = 0;
        if(_imgWidth / _imgHeight > vp.w / vp.h){
            largeWidth = vp.h * _imgWidth / _imgHeight;
            largeHeight = vp.h;
            left = (vp.w - largeWidth) / 2;
        }else{
            largeWidth = vp.w;
            largeHeight = vp.w * _imgHeight / _imgWidth;
            top = (vp.h - largeHeight) / 2;
        }
        _img.width = largeWidth;
        _img.height = largeHeight;
        dojo.attr(_img, {
            style:{
                'left': left + "px",
                'top': top + "px"
            }
        });
    } else {
        sizeToWindowFloorplan(_img);
    }
};

var sizeToWindowFloorplan = function(_img) {
    var vp = dojo.window.getBox();
    var largeWidth;
    var largeHeight;
    var left = 0;
    var top = 0;
    var _imgWidth = selectData.items[slideIndex].width;
    var _imgHeight = selectData.items[slideIndex].height;
    if(_imgWidth / _imgHeight > vp.w / vp.h){
        largeWidth = vp.w;
        largeHeight = vp.w * _imgHeight / _imgWidth;
        top = (vp.h - largeHeight) / 2;
    }else{
        largeWidth = vp.h * _imgWidth / _imgHeight;
        largeHeight = vp.h;
        left = (vp.w - largeWidth) / 2;
    }
    _img.width = largeWidth;
    _img.height = largeHeight;
    dojo.attr(_img, {
        style:{
            'left': left + "px",
            'top': top + "px",
            'MozBoxShadow': '0 0 10px rgba(0,0,0,0.5)',
            'webkitBoxShadow': '0 0 10px rgba(0,0,0,0.5)',
            'boxShadow': '0 0 10px rgba(0,0,0,0.5)'
        }
    });
};

var sizeToAnim = function(_img) {
    var vp = dojo.window.getBox();
    var largeWidth = 0;
    var largeHeight = 0;
    var _imgWidth = selectData.items[slideIndex].width;
    var _imgHeight = selectData.items[slideIndex].height;
    if(_imgWidth / _imgHeight > vp.w / vp.h){
        largeWidth = vp.h * _imgWidth / _imgHeight;
        largeHeight = vp.h;
    }else{
        largeWidth = vp.w;
        largeHeight = vp.w * _imgHeight / _imgWidth;
    }
    var left = 0;
    var top = 0;
    if(((vp.w > vp.h && largeWidth > largeHeight) || (vp.w < vp.h && largeWidth < largeHeight)) && (vp.w * vp.h < largeWidth * largeHeight * 1.1)) {
        var left = (largeWidth - largeWidth%9) / 9;
        var top = (largeHeight - largeHeight%9) / 9;
    }
    _img.width = largeWidth + left;
    _img.height = largeHeight + top;
    if(isResize == false){
        random = Math.floor(Math.random()*3);
    }
    if(random == 0){
        dojo.attr(_img, {
            style:{
                'left': 0 + 'px',
                'top': 0 + 'px'
            }
        });
    }
    if(random == 1){
        dojo.attr(_img, {
            style:{
                'left': (vp.w - _img.width) + 'px',
                'top': (vp.h - _img.height) + 'px'
            }
        });
    }
    if(random == 2){
        dojo.attr(_img, {
            style:{
                'left': 0 + 'px',
                'top': (vp.h - _img.height) + 'px'
            }
        });
    }
    if(random == 3){
        dojo.attr(_img, {
            style:{
                'left': (vp.w - _img.width) + 'px',
                'top': 0 + 'px'
            }
        });
    }
};

var changeSlide = function() {
    var vp = dojo.window.getBox();
    var slideshow = dojo.byId("slideshow");
    interval = 0;
    isPauseAnimation = false;
    if(dojo.isIos) {
        window.scrollTo(0, 0);
        if(vp.w > vp.h) {
            dojo.attr(dojo.byId("divPanel"), {
                style: {'top' : (vp.h - panelHeight) / 2 + "px"}
            });
        } else {
            dojo.attr(dojo.byId("divPanel"), {
                style: {'top' : "5px"}
            });
        }
    }
    if(dojo.isIE < 9){
        dojo.fadeIn({
            node: dojo.byId("loading"),
            duration: 200
        }).play();
        dojo.fadeIn({
            node: dojo.byId("loadingGif"),
            duration: 200
        }).play();
    } else {
        dojo.attr(dojo.byId("loading"), {
            'class': 'changeSlide topSlide'
        });
    }
    dojo.attr(dojo.byId(slideIndex + ""), {
        style:{
            'borderColor': '#4d90fe'
        }
    });
    var divSlide = dojo.create("div", {
        id: imgId,
        style: {'opacity': '0',
                'width': vp.w + 'px',
                'height': vp.h + 'px',
                'position': 'absolute',
                'backgroundColor': '#eeeeee',
                'font': '6vw sans-serif',
                'textAlign': 'center',
                //'textShadow': 'grey 0px 0px 5px',
                'display':'block'}
    }, slideshow);
    if(isMobileDevice){
        $$(divSlide).swipeRight(function() {
            prevSlide();
        });
        $$(divSlide).swipeLeft(function() {
            nextSlide();
        });
        $$(divSlide).tap(function() {
            dojo.attr(dojo.byId("divPanel"), {
                style:{
                    'opacity': '1'
                }
            });
            timeoutId = setTimeout(hideFishEye, 3000);
            window.scrollTo(0, 0);
        });
    }
    if(selectData.items[slideIndex].generate) {
        imgId = (imgId == "imgSlide1") ? "imgSlide2" : "imgSlide1";
        if(dojo.byId(imgId)){
            dojo.destroy(dojo.byId(imgId));
        }
        // if(dojo.byId("imgSlide2")){
        //     dojo.destroy(dojo.byId("imgSlide2"));
        // }


        var anim = dojo.fadeIn({
            node: divSlide,
            duration: 500
        }).play();
        if(selectData.items[slideIndex].type == "address") {
            var divText = dojo.create("div", {
                style: {
                    'display':'table-cell',
                    'verticalAlign': 'middle',
                    'backgroundColor': '#eeeeee',
                    'color': '#393939'
                }
            }, divSlide);
            var divText2 = dojo.create("div", {}, divText);
            divText2.innerHTML = propertyAddress;
        }
        if(selectData.items[slideIndex].type == "zView") {
            var iframe = dojo.create("iframe", {
                id: "zView",
                src: selectData.items[slideIndex].url,
                width: "100%",
                height: "100%",
                style: {'display': 'block'}
            }, divSlide);
        }
        if(dojo.isIE < 9){
            dojo.fadeOut({
                node: dojo.byId("loading"),
                duration: 200
            }).play();
            dojo.fadeOut({
                node: dojo.byId("loadingGif"),
                duration: 200
            }).play();
        } else {
            dojo.attr(dojo.byId("loading"), {
                'class': 'changeSlide'
            });
        }
        if(isPlay) {
            statusBarAnimation = dojo.fx.slideTo({
                left: 0,
                node: dojo.byId("statusBarActive"),
                duration: 5000
            }).play();
        }
        if (slideTimer != null){
            clearTimeout(slideTimer);
        }
        slideTimer = setTimeout(function(){
            if(isPlay){
                dojo.attr(dojo.byId(slideIndex + ""), {
                    style:{
                        'borderColor': '#cccccc'
                    }
                });
                slideIndex = ((slideIndex + 1) == selectData.items.length) ? 0 : (slideIndex + 1);
                isResize = false;
                changeSlide();
            }
            slideTimer = null;
        }, 5000);

        //------------------statusbar----------------------\\
        var statusBarLeft = ((vp.w + vp.w%2) / 2 - 72) + 'px';
        var statusBarActiveLeft = '-144px';
        if(isMobileDevice) {
            statusBarLeft = 0 + 'px';
            statusBarActiveLeft = '-' + vp.w + 'px';
        }
        dojo.attr(dojo.byId("statusBar"), {
            style:{
                left: statusBarLeft,
                display: "inline"
            }
        });
        dojo.attr(dojo.byId("statusBarActive"), {
            style:{
                left: statusBarActiveLeft
            }
        });
    } else {
        var imgURL;
        if(vp.w > 1280 && selectData.items[slideIndex].larger){
            imgURL = selectData.items[slideIndex].larger;
        } else {
            imgURL = selectData.items[slideIndex].large;
        }
        var imgSlide = dojo.create("img", {
            id: imgId + '0',
            'class': 'slide',
            //src: imgURL,
            style: {'position': 'absolute',
                    'top': '0px',
                    'left': '0px'}
        }, divSlide);
        var connectOnLoad = dojo.connect(imgSlide, 'onload', function(){
            dojo.disconnect(connectOnLoad);
            if(dojo.isIE < 9){
                dojo.fadeOut({
                    node: dojo.byId("loading"),
                    duration: 200
                }).play();
                dojo.fadeOut({
                    node: dojo.byId("loadingGif"),
                    duration: 200
                }).play();
            } else {
                dojo.attr(dojo.byId("loading"), {
                    'class': 'changeSlide'
                });
            }
            //------------------statusbar----------------------\\
            var statusBarLeft = ((vp.w + vp.w%2) / 2 - 72) + 'px';
            var statusBarActiveLeft = '-144px';
            if(isMobileDevice) {
                statusBarLeft = 0 + 'px';
                statusBarActiveLeft = '-' + vp.w + 'px';
            }
            dojo.attr(dojo.byId("statusBar"), {
                style:{
                    left: statusBarLeft,
                    display: "inline"
                }
            });
            dojo.attr(dojo.byId("statusBarActive"), {
                style:{
                    left: statusBarActiveLeft
                }
            });
            //------------------statusbar----------------------\\
            getImageDimensions(imgSlide);
            if(selectData.items[slideIndex].type == "Floorplan"){
                sizeToWindowFloorplan(imgSlide);
                isFloorplan = true;
            } else {
                if((dojo.isWebKit > 500 || dojo.isFF > 10 || dojo.isOpera >= 12 || dojo.isIE > 9) && !disableAnim){
                    sizeToAnim(imgSlide);
                    isFloorplan = false;
                } else {
                    if(isMobileDevice) {
                        sizeToWindow(imgSlide);
                        isFloorplan = true;
                    } else {
                        sizeToWindowFloorplan(imgSlide);
                        isFloorplan = true;
                    }
                }
            }
            var anim = dojo.fadeIn({
                node: divSlide,
                duration: 500
            }).play();
            dojo.connect(anim, 'onEnd', function(){
                imgId = (imgId == "imgSlide1") ? "imgSlide2" : "imgSlide1";
                if(dojo.byId(imgId) != null){
                    dojo.destroy(dojo.byId(imgId));
                }
            });
            if((dojo.isWebKit > 500 || dojo.isFF > 10 || dojo.isOpera >= 12 || dojo.isIE > 9) && !selectData.items[slideIndex].type && !disableAnim){
                if(isPlay) {
                    statusBarAnimation = dojo.fx.slideTo({
                        left: 0,
                        node: dojo.byId("statusBarActive"),
                        duration: 10000
                    }).play();
                }
                t = (parseFloat(imgSlide.style.top) == 0)?(vp.h - imgSlide.height):(imgSlide.height - vp.h);
                l = (parseFloat(imgSlide.style.left) == 0)?(vp.w - imgSlide.width):(imgSlide.width - vp.w);
                s = ((vp.w > vp.h && imgSlide.width > imgSlide.height) || (vp.w < vp.h && imgSlide.width < imgSlide.height)) ? 1.3 : 1;

                dojo.attr(imgSlide, {
                    style:{
                        'transform': 'scale(' + s + ')translate(' + l + 'px, ' + t + 'px)',
                        'MozTransform': 'scale(' + s + ')translate3d(' + l + 'px, ' + t + 'px, 0px)',
                        '-webkit-transform': 'scale(' + s + ')translate3d(' + l + 'px, ' + t + 'px, 0px)',
                        'OTransform': 'scale(' + s + ')translate(' + l + 'px, ' + t + 'px)',
                        '-webkit-transition': '-webkit-transform 10s linear'
                    }
                });
                startTime = new Date();
                var eventName = null;
                if(dojo.isWebKit) {
                    eventName = "webkitTransitionEnd";
                } else if(dojo.isFF || dojo.isIE > 9) {
                    eventName = "transitionend";
                } else if(dojo.isOpera) {
                    eventName = "oTransitionEnd";
                }
                imgSlide.addEventListener(eventName, prepareChangeSlide, true);
            } else {
                if(isPlay) {
                    statusBarAnimation = dojo.fx.slideTo({
                        left: 0,
                        node: dojo.byId("statusBarActive"),
                        duration: 5000
                    }).play();
                }
                if (slideTimer != null){
                    clearTimeout(slideTimer);
                }
                slideTimer = setTimeout(function(){
                    prepareChangeSlide();
                    slideTimer = null;
                }, 5000);
            }
        });
        dojo.attr(imgSlide, {
            src: imgURL
        });
    }
};

var prepareChangeSlide = function() {
    if(isPlay){
        dojo.attr(dojo.byId(slideIndex + ""), {
            style:{
                'borderColor': '#cccccc'
            }
        });
        slideIndex = ((slideIndex + 1) == selectData.items.length) ? 0 : (slideIndex + 1);
        isResize = false;
        changeSlide();
    }
};

var resize = function() {
    var vp = dojo.window.getBox();
    if(tempHeigth != vp.h || tempWidth != vp.w) {
        tempHeigth = vp.h;
        tempWidth = vp.w;

        if(!isMobileDevice) {
            dojo.attr(dojo.byId("divDown"), {
                style:{
                    'left': (vp.w * 0.15) + 'px',
                    'width': (vp.w - vp.w * 0.3) + 'px'
                }
            });
            dojo.attr(dojo.byId("prevSlide"), {
                style:{
                    'left': ((vp.w + vp.w%2) / 2 - 75) + 'px'
                }
            });
            dojo.attr(dojo.byId("nextSlide"), {
                style:{
                    'left': ((vp.w + vp.w%2) / 2 + 25) + 'px'
                }
            });
            dojo.attr(dojo.byId("playPause"), {
                style:{
                    'left': ((vp.w + vp.w%2) / 2 - 25) + 'px'
                }
            });
            dojo.attr(dojo.byId("statusBar"), {
                style:{
                    left:((vp.w + vp.w%2) / 2 - 72) + 'px'
                }
            });

            if (resizeTimer != null){
                clearTimeout(resizeTimer);
            }
            resizeTimer = setTimeout(function(){
                isResize = true;
                changeSlide();
                resizeTimer = null;
                console.log("Resize");
            }, 500);
        } else {
            curYPos = 0;
            curTop = 0;
            curDown = false;
            lastTop = 0;
            dojo.attr(dojo.byId("divDown"), {
                style: {'top' : "0px"}
            });
            if(dojo.isIos) {
                if(vp.w > vp.h) {
                    dojo.attr(dojo.byId("divPanel"), {
                        style: {'top' : (vp.h - panelHeight) / 2 + "px"}
                    });
                } else {
                    dojo.attr(dojo.byId("divPanel"), {
                        style: {'top' : "5px"}
                    });
                }
            }
            window.scrollTo(0, 0);

            isResize = true;
            changeSlide();
        }
    }
};

/// get data

var homeLink = "";

var getImageListJson = function(data, customerInfo) {
    //sort
    if(data.photoData.length === 0 && data.planData.length === 0 && data.zviewData.length === 0) {
        onError();
        return;
    }

    photoData.items = zSort(data.photoData);
    planData.items = zSort(data.planData);

    setCustomerInfoOpts(customerInfo);
    renderMainUI();
};

var setCustomerInfoOpts = function(customerInfo) {
    if(customerInfo) {
        var officeLevel = customerInfo.type;
        if(officeLevel === "AB") {
            homeLink = customerInfo.homePage;
            if(homeLink && homeLink.indexOf("http://") == -1) {
                homeLink = "http://" + homeLink;
            }
        }
        var listOptionParameters = customerInfo["ns2.short-option-param-list"];
        if(listOptionParameters) {
            var optionParameters = listOptionParameters["ns2.short-option-param"];
            if (optionParameters instanceof Array) {
                for (var i = 0; i < optionParameters.length; i++) {
                    for (var j in customerOptions) {
                        var optTypeName = optionParameters[i].optionType + optionParameters[i].name;
                        if(optTypeName === customerOptions[j].name && customerOptions[j].value === "") {
                            customerOptions[j].value = optionParameters[i].value + "";
                        }
                    }
                }
            } else {
                for (var j in customerOptions) {
                    var optTypeName = optionParameters.optionType + optionParameters.name;
                    if(optTypeName === customerOptions[j].name && customerOptions[j].value === "") {
                        customerOptions[j].value = optionParameters.value + "";
                    }
                }
            }
        }

        if (officeLevel !== "HO") {
            var allValuesSetted = true;
            for (var j in customerOptions) {
                if (customerOptions[j].value == "") {
                    allValuesSetted = false;
                    break;
                }
            }
            if (!allValuesSetted) {
                setCustomerInfoOpts(customerInfo.parent);
            }
        }
    }
};

// OLD XML logic
// DEPRECATED

var getImageList = function(imageList, store, customerId) {
    if(imageList.length == 0) {
        console.log("imageList is empty.");
    } else {
        var items = store.getValue(imageList[0], "images");
        var data = populateDataFromXmlStore(store, imageList[0]);
        //sort
        photoData.items = zSort(data.photoData);
        planData.items = zSort(data.planData);

        if(!(store.getValue(imageList[0], "others") === undefined)) {
            var othersItems = store.getValue(imageList[0], "others");
            var others = store.getValues(othersItems, "other");
            for (var j = 0; j < others.length; j++){
                if(store.getValue(others[j], "file-type") == "EPC") {
                    if(!(store.getValue(others[j], "link") === undefined)) {
                        epcLink = zImgPath + store.getValue(others[j], "link");
                        buttonCount++;
                    }
                }
            }
        }
        if(!(store.getValue(imageList[0], "externalUrls") === undefined)) {
            var externalUrlItems = store.getValue(imageList[0], "externalUrls");
            var externalUrls = store.getValues(externalUrlItems, "externalUrl");
            for (var j = 0; j < externalUrls.length; j++){
                if((store.getValue(externalUrls[j], "hidden") + "") == "false") {
                    if((store.getValue(externalUrls[j], "name") + "") == "walk3d") {
                        walk3dLink = store.getValue(externalUrls[j], "url") + "";
                        buttonCount++;
                    }
                    if((store.getValue(externalUrls[j], "name") + "") == "attachment") {
                        attachmentLink = store.getValue(externalUrls[j], "url") + "";
                        buttonCount++;
                    }
                }
            }
        }
        if(photoData.items.length > 0 || planData.items.length > 0){
            if(customerId) {
                createCustomerInfoStore(customerId);
            } else {
                renderMainUI();
            }
        }

    }
};

var createCustomerInfoStore = function(customerId) {
    var custInfoStore = new dojox.data.XmlStore({
        url: cfg.customerXMLURL + customerId, rootItem: "customer-info"
    });
    custInfoStore.fetch({
        onComplete: (customerInfo) => {
            getCustomerInfo(customerInfo, custInfoStore);
        },
        onError: function(error) {
            console.error(error);
            renderMainUI();
        }
    });
};

var getCustomerInfo = function(customerInfo, store) {
    if (customerInfo.length != 0) {
        var officeLevel = store.getValue(customerInfo[0], "type") + "";
        if(officeLevel == "AB") {
            homeLink = store.getValue(customerInfo[0], "homePage") + "";
            if(homeLink.indexOf("http://") == -1) {
                homeLink = "http://" + homeLink;
            }
        }
        var listOptionParameters = store.getValue(customerInfo[0], "ns2:short-option-param-list");
        var optionParameters = store.getValues(listOptionParameters, "ns2:short-option-param");
        for (var i = 0; i < optionParameters.length; i++) {
            for (var j in customerOptions) {
                if (store.getValue(optionParameters[i], "optionType") + store.getValue(optionParameters[i], "name") + "" == customerOptions[j].name && customerOptions[j].value == "") {
                    customerOptions[j].value = store.getValue(optionParameters[i], "value") + "";
                }
            }
        }
        if (officeLevel != "HO") {
            var allValuesSetted = true;
            for (var j in customerOptions) {
                if (customerOptions[j].value == "") {
                    allValuesSetted = false;
                    break;
                }
            }
            if (!allValuesSetted) {
                createCustomerInfoStore(store.getValue(customerInfo[0], "parentId") + "");
            } else {
                renderMainUI();
            }
        } else {
            renderMainUI();
        }
    } else {
        renderMainUI();
    }
};
